/**
 * Linked cost (BL-8550fb1c): the cost of the token records tied to a set of agent sessions, shown next to their
 * time. "estimate" when some of it was priced from token counts; an amber note for sessions that ended without
 * reporting their cost, or are waiting on their orchestrator's ("cost pending").
 */

import { formatCostUsd, missingCostNote } from '../../services/agentSessionService';

interface LinkedCostProps {
  usd: number | undefined;
  missingSessions: number | undefined;
  /** Sessions whose orchestrator is still to report the cost. */
  pendingSessions?: number;
  estimated: boolean | undefined;
  /** Shown before the figure, e.g. "Linked cost: ". */
  label?: string;
  className?: string;
}

export function LinkedCost({ usd, missingSessions, pendingSessions, estimated, label = 'linked cost ', className }: LinkedCostProps) {
  const note = missingCostNote(missingSessions, pendingSessions);
  return (
    <span className={className} title="The cost of the token records tied to these sessions">
      {label}
      <span className="font-semibold">{formatCostUsd(usd)}</span>
      {estimated && <span className="text-gray-500"> (estimate)</span>}
      {note && <span className="text-amber-700">{note}</span>}
    </span>
  );
}
